import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, Inject } from "@angular/core";
import { MasterDataDataService } from "src/app/share/data-service/master-data.data.service";
import { AlertService } from "src/app/share/service/alert.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { PersonalProtectionDataService } from "src/app/share/data-service/personal-perotection/personal-protection.data.service";

@Component({
  selector: "app-cancel-policy",
  templateUrl: "./cancel-policy.component.html",
  styleUrls: ["./cancel-policy.component.scss"]
})
export class CancelPolicyComponent {
  rejectReasonList: string[] = [];
  formGroup: FormGroup;

  id: string;
  itemPolicyNo: string;

  constructor(
    private dialogRef: MatDialogRef<CancelPolicyComponent>,
    private alertService: AlertService,
    private masterDataService: MasterDataDataService,
    private personalprotectionDataService: PersonalProtectionDataService,
    @Inject(MAT_DIALOG_DATA) public data: CancelPolicyComponent
  ) {
    this.initForm();
    //this.getRejectReasonSelection();
    this.itemPolicyNo = data.itemPolicyNo;
    this.id = data.id;
  }

  private initForm() {
    // this.formGroup = new FormGroup({
    //   CancelReason: new FormControl(null, Validators.required),
    //   Remarks: new FormControl(null, Validators.required),
    //   RefundAmount: new FormControl(null, Validators.min(0.01))
    // });
  }

  private getRejectReasonSelection() {
    this.masterDataService.getRejectReasonSelection().subscribe({
      next: (x: string[]) => {
        this.rejectReasonList = x;
      },
      error: (err) => {
        this.alertService.openSnackBar(err.error);
      }
    });
  }

  onConfirm() {
    let fd = new FormData();

    // if (this.formGroup.value.CancelReason) {
    //   fd.append("CancelReason", this.formGroup.value.CancelReason);
    // }
    // if (this.formGroup.value.Remarks) {
    //   fd.append("Remarks", this.formGroup.value.Remarks);
    // }
    // if (this.formGroup.value.RefundAmount) {
    //   fd.append("RefundAmount", this.formGroup.value.RefundAmount);
    // }

    this.personalprotectionDataService.deactivatePolicy(this.id, fd).subscribe({
      next: (x) => {
        this.alertService.openSnackBar("Policy successfully cancelled");

        this.dialogRef.close(true);
      },
      error: (err) => {
        this.alertService.openSnackBar(`Error cancelling policy: ${err.error}`);
      }
    });
  }
}
